import { StyleSheet } from "react-native";
import { typography } from '@shared/config/typographyConfig';
import { colorPalette } from '@shared/config/colorsConfig';

const tabNavigatorStyle = StyleSheet.create({
    tabBar: {
        backgroundColor: colorPalette.white,
        borderTopWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderTopColor: colorPalette.gray[300],
        borderLeftColor: colorPalette.gray[300],
        borderRightColor: colorPalette.gray[300],
        paddingVertical: 20,
        overflow: 'hidden',
        height: 90,
        elevation: 0,
        shadowColor: 'transparent',
        shadowOpacity: 0,
        shadowRadius: 0,
        shadowOffset: { width: 0, height: 0 },
    },
    tabBarItem: {
        paddingVertical: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    tabBarIcon: {
        height: 40,
        width: 40,
        alignItems: 'center',
        justifyContent: 'center',
    },
    tabBarLabel: {
        fontSize: typography.fontSize.base,
        fontWeight: '500',
    },
});

export default tabNavigatorStyle;